var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"single-actions":_vm.singleActions},on:{"refresh":_vm.refreshRule}})}
var staticRenderFns = []

export { render, staticRenderFns }